import { getEnvironmentConfiguration } from "./environments/environment-configuration";

//API
export const BASE_URL: string = getEnvironmentConfiguration().ApiEndpoint;
export const MERCHANTS_URL: string = BASE_URL + 'Merchant';
export const BUY_URL: string = BASE_URL + 'Voucher/Buy';
export const REDEEM_URL: string = BASE_URL + 'Voucher/Redeem';
export const CANCEL_URL: string = BASE_URL + 'Voucher/Cancel';
export const RESEND_NOTIFICATION_URL: string = BASE_URL + 'Voucher/ResendPaymentNotification';
export const REDEEM_TIMEOUT_SECONDS: number = 150;

// Video tutorials
export const GLOVO_VIDEO: string = 'https://www.youtube.com/embed/68wnmaC4ogs';
export const GLOVO_PLAY_STORE: string = 'https://play.google.com/store/apps/details?id=com.glovo';
export const GLOVO_APP_STORE: string = 'https://apps.apple.com/pt/app/glovo-entrega-de-comida-e-mais/id951812684';
export const GLOVO_APP_GALLERY: string = 'https://appgallery.huawei.com/#/app/C8314317';

export const DIGIN_VIDEO: string = 'https://www.youtube.com/embed/A3vZNIweSPQ';
export const DIGIN_PLAY_STORE: string = 'https://play.google.com/store/apps/details?id=com.outdarelab.zomato';
export const DIGIN_APP_STORE: string = 'https://apps.apple.com/pt/app/zomato-delivery-takeaway/id1579325286?l=en&fbclid=IwAR2AEwu8enEaTCrWLepiuN5WNG-56as1h38iXaW4IokDrekiuwbYdjUdwyw';
export const DIGIN_APP_GALLERY: string = 'https://appgallery.huawei.com/#/app/C101529369';

